import { MandateStatus } from "./mandate";

export const mandateStatusLabels = {
  [MandateStatus.ALL]: "mandates.status.all",
  [MandateStatus.ACTIVE]: "mandates.status.active",
  [MandateStatus.CONSUMED]: "mandates.status.consumed",
  [MandateStatus.CREDITOR_OPPOSED]: "mandates.status.creditorOpposed",
  [MandateStatus.OBSOLETE]: "mandates.status.obsolete",
  [MandateStatus.OPPOSED]: "mandates.status.opposed",
  [MandateStatus.REVOKED]: "mandates.status.revoked",
};
